export default __webpack_public_path__ + "3bdb83131f2c8d25d6f127707a94d5a0.svg";